exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.c-textarea {\n  margin-top: 5px;\n}\n.guidance-editor .toolbar {\n  padding: 5px 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/happypack/loader.js?id=css!./~/vue-loader/lib/style-compiler?{"id":"data-v-12daed38","scoped":false,"hasInlineConfig":false}!./~/happypack/loader.js?id=less!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/textarea.vue
// module id = 517
// module chunks = 23